import type { CompetitionRepository } from "@/modules/leagues/repositories/CompetitionRepository";
import type { Competition } from "@/modules/football/types/football";
import { footballDataService } from "@/services/football/FootballDataService";

/** Implementação REAL — usada quando USE_MOCK_DATA = false (ver src/config/dataSource.ts). */
export class FootballDataCompetitionRepository implements CompetitionRepository {
  async getCompetitions(): Promise<Competition[]> {
    return footballDataService.getCompetitions();
  }
}
